import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationStart, Router, RoutesRecognized } from '@angular/router';
import { Subject, filter, takeUntil } from 'rxjs';
import { AuthFacade } from 'src/app/auth/store/auth.facade';
import { AppFacade } from '../../store/app.facade';
import { AuthService } from 'src/app/auth/services';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(
    private appFacade: AppFacade,
    private authFacade: AuthFacade,
    private authService: AuthService,
    private router: Router,
  ) {
    this.router.events
      .pipe(
        filter(e => e instanceof NavigationStart),
        takeUntil(this.destroy$)
      )
      .subscribe((event) => {
        const urlSegments = (event as NavigationStart).url.split('/');
        if (urlSegments.length >= 3 && urlSegments[1].toLowerCase() === 's') {
          authService.setSecretGuid(urlSegments[2]);
        }
        else {
          authService.setSecretGuid('');
        }
        this.authFacade.getAuthUser();
      });
    this.router.events
      .pipe(
        filter(e => e instanceof RoutesRecognized),
        takeUntil(this.destroy$)
      )
      .subscribe((event) => {
        this.appFacade.SetTitle((event as RoutesRecognized).state.root.firstChild.data.title);
      });

  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
